import React, { useEffect, useState } from "react"
import { Col, Container, Modal, Row } from "react-bootstrap"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { Button } from "primereact/button"
import { MultiSelect } from "primereact/multiselect"
import { Calendar } from "primereact/calendar"
import CompanySelector from "ATSComponents/Common/CompanySelector"
import * as XLSX from "xlsx"
import { Table } from "react-bootstrap"
import { saveAs } from "file-saver"
import axios from "axios"
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer"
const RecruitersReports = () => {
  document.title = "ATS - Recruiter Reports";
  const userInfos = JSON.parse(sessionStorage.getItem("user-info"))
  const intialcompanyId =
    userInfos?.user_details?.companies_data?.[0]?.company_id
  const [companyId, setCompanyId] = useState(intialcompanyId)
  const [recruiterList, setRecruiterList] = useState([])
  const [jobTitleList, setJobTitleList] = useState([])
  const [loadingRecruiters, setLoadingRecruiters] = useState(false)
  const [loadingJobs, setLoadingJobs] = useState(false)
  const [loading, setLoading] = useState(false)
  const [reports, setReports] = useState([])
  const [selectedRecruiters, setSelectedRecruiters] = useState([])
  const [selectedJobs, setSelectedJobs] = useState([])
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)
  const [showJoinedModal, setShowJoinedModal] = useState(false)
  const [joinedDetails, setJoinedDetails] = useState([])
  const [selectedRows, setSelectedRows] = useState([])
  const CustomLoader = () => (
    <OrgTableShimmer columns={6} rows={6} titleWidth="220px" />
  )
  const handleJoinedClick = row => {
    setJoinedDetails(row.hrms_candidates || [])
    setShowJoinedModal(true)
  }
  const formatLocalDate = date => {
    if (!date) return null

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")

    return `${year}-${month}-${day}`
  }
  const handleResetFilters = () => {
    setSelectedRecruiters([])
    setSelectedJobs([])
    setFromDate(null)
    setToDate(null)
    setSelectedRows([])
  }
  const show = v => (v === null || v === undefined || v === "" ? "-" : v)
  const formatDate = d => {
    if (!d) return "-"
    const date = new Date(d)
    return `${String(date.getDate()).padStart(2, "0")}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${date.getFullYear()}`
  }
  const fetchAlluserlist = async () => {
    try {
      setLoadingRecruiters(true)
      const res = await axios.get(
        `/api/v1/get-all-recruiters/?company_id=${companyId}`
      )
      const transformed = res.data.map(u => ({
        label: `${u.first_name || ""} ${u.middle_name || ""} ${
          u.last_name || ""
        }`.trim(),
        value: u.id,
      }))
      setRecruiterList(transformed)
    } finally {
      setLoadingRecruiters(false)
    }
  }
  const getJobTitles = async () => {
    try {
      setLoadingJobs(true)
      const res = await axios.get(
        `/api/v1/create-job-order/?company_id=${companyId}`
      )
      const jobs = (res.data.results || []).map(j => ({
        label: j.job_title,
        value: j.job_id,
      }))
      setJobTitleList(jobs)
    } finally {
      setLoadingJobs(false)
    }
  }
  const [totalRecords, setTotalRecords] = useState(0)
  const [first, setFirst] = useState(0)
  const [rows, setRows] = useState(10)
  const getTrackerReports = async (page = 1) => {
    try {
      setLoading(true)

      const params = {
        company_id: companyId,
        page: page,
      }

      if (selectedRecruiters.length)
        params.recruiter_id = selectedRecruiters.join(",")

      if (selectedJobs.length) params.job_id = selectedJobs.join(",")

      if (fromDate) params.from_date = formatLocalDate(fromDate)
      if (toDate) params.to_date = formatLocalDate(toDate)

      const res = await axios.get(`/api/v1/tracker-report/`, { params })

      const reportData = res.data?.results?.data || []

      setReports(
        reportData.map((r, i) => ({
          ...r,
          _rowId: r.job_id || i,
        }))
      )
      setTotalRecords(res.data.count || 0)
    } catch (err) {
      console.log("Tracker Report Error:", err)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    if (!companyId) return
    fetchAlluserlist()
    getJobTitles()
    // getTrackerReports()
  }, [companyId])
  useEffect(() => {
    setSelectedRecruiters([])
    setSelectedJobs([])
    setFromDate(null)
    setToDate(null)
    setSelectedRows([])
  }, [])
  useEffect(() => {
    if (!companyId) return
    setFirst(0)
    getTrackerReports(1)
  }, [selectedRecruiters, selectedJobs, fromDate, toDate, companyId])
  const handleCompanyChange = c => {
    if (c?.company_id) setCompanyId(c.company_id)
  }
  const exportExcel = () => {
    const dataToExport = selectedRows.length ? selectedRows : reports

    const formatted = dataToExport.map(r => ({
      JobOrder: show(r.requirement),
      Recruiter: show(r.handled_by),
      Priority: show(r.priority),
      TotalPositions: show(r.positions),
      OpenPositions: show(r.open_positions || r.positions),
      ClosedPositions: show(r.closed_positions || 0),
      YetToJoin: show(r.ytj),
      Joined: show(r.joined),
      Level1: show(r["Level 1"]),
      Level2: show(r["Level 2"]),
      Remarks: show(r.Remarks),
      Status: r.Active ? "Open" : "Close",
    }))

    const worksheet = XLSX.utils.json_to_sheet(formatted)
    const workbook = { Sheets: { Reports: worksheet }, SheetNames: ["Reports"] }

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    })

    saveAs(
      new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
      "Recruiter_Reports.xlsx"
    )
  }
  const statusTemplate = row => {
    const isActive = row.Active === "Active"

    return (
      <span className={`badge ${isActive ? "bg-success" : "bg-secondary"}`}>
        {isActive ? "Open" : "Close"}
      </span>
    )
  }
  const recruiterTemplate = rowData => {
    return (
      <div className="recruiter-box" title={rowData["handled_by"]}>
        {rowData["handled_by"]}
      </div>
    )
  }
  return (
    <div className="page-content allact-tabs">
      <Container fluid>
        <div className="page-title-box actjobbread mb-0">
          <Row className="align-items-center actjobsum">
            <Col xxl={6}>
              <h1 className="page-title">Recruiter Reports</h1>
            </Col>
            <Col xxl={6} className="d-flex justify-content-end gap-2">
              <div>
                <label className="me-2 mb-0">Select Company</label>
                <div style={{ width: 170 }}>
                  <CompanySelector onCompanyChange={handleCompanyChange} />
                </div>
              </div>
              <div>
                <div className="invisible">in</div>
                <Button
                  label="Excel"
                  icon="pi pi-file-excel"
                  title="Download"
                  className="btn btn-primary mt-0 blueBtn d-none"
                  onClick={exportExcel}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="d-flex gap-4 flex-wrap mb-2">
                <div style={{ minWidth: 300 }}>
                  <div>
                    <label className="form-label mb-1 fw-bold">
                      Select Job Order
                    </label>
                  </div>
                  <MultiSelect
                    value={selectedJobs}
                    options={jobTitleList}
                    onChange={e => setSelectedJobs(e.value)}
                    optionLabel="label"
                    optionValue="value"
                    placeholder={loadingJobs ? "Loading jobs..." : "Job Order"}
                    display="chip"
                    loading={loadingJobs}
                    filter
                    filterPlaceholder="Search job..."
                    tooltip={selectedJobs
                      .map(v => jobTitleList.find(j => j.value === v)?.label)
                      .join(", ")}
                    tooltipOptions={{ position: "top" }}
                    style={{ width: "290px" }}
                  />
                </div>
                <div style={{ minWidth: 300 }}>
                  <div>
                    <label className="form-label mb-1 fw-bold">
                      Select Recruiter
                    </label>
                  </div>
                  <MultiSelect
                    value={selectedRecruiters}
                    options={recruiterList}
                    onChange={e => setSelectedRecruiters(e.value)}
                    optionLabel="label"
                    optionValue="value"
                    placeholder={
                      loadingRecruiters ? "Loading recruiters..." : "Recruiter"
                    }
                    display="chip"
                    loading={loadingRecruiters}
                    filter
                    filterPlaceholder="Search recruiter..."
                    tooltip={selectedRecruiters
                      .map(v => recruiterList.find(r => r.value === v)?.label)
                      .join(", ")}
                    tooltipOptions={{ position: "top" }}
                    style={{ width: "290px" }}
                  />
                </div>
                <div style={{ minWidth: 200 }}>
                  <div>
                    <label className="form-label mb-1 fw-bold">From Date</label>
                  </div>
                  <Calendar
                    value={fromDate}
                    onChange={e => setFromDate(e.value)}
                    placeholder="From Date"
                    showIcon
                    dateFormat="dd-mm-yy"
                    style={{ width: "200px" }}
                  />
                </div>
                <div style={{ minWidth: 200 }}>
                  <div>
                    <label className="form-label mb-1 fw-bold">To Date</label>
                  </div>
                  <div className="d-flex gap-2 align-items-center">
                    <Calendar
                      value={toDate}
                      onChange={e => setToDate(e.value)}
                      placeholder="To Date"
                      showIcon
                      dateFormat="dd-mm-yy"
                      style={{ width: "200px" }}
                    />
                    <button
                      className="btn btn-primary"
                      onClick={handleResetFilters}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="card p-2">
                {loading ? (
                  <CustomLoader />
                ) : (
                  <DataTable
                  id="RecruiterReports_TableView"
                    value={reports}
                    paginator
                    lazy
                    first={first}
                    rows={rows}
                    totalRecords={totalRecords}
                    rowsPerPageOptions={[10, 20, 30, 50,totalRecords]}
                    // paginatorTemplate="RowsPerPageDropdown PrevPageLink PageLinks NextPageLink"
                    onPage={e => {
                      setFirst(e.first)
                      setRows(e.rows)
                      const page = e.page + 1
                      getTrackerReports(page)
                    }}
                    scrollable
                    scrollHeight="550px"
                    dataKey="_rowId"
                  >
                    {/* <Column
                      selectionMode="multiple"
                      className="d-none"
                      headerStyle={{ width: 50 }}
                    /> */}
                    <Column
                      field="Job_order"
                      header="Job Order"
                      body={r => show(r.requirement)}
                    />
                    {/* <Column
                      field="handled by"
                      header="Recruiter Name"
                    /> */}
                    <Column
                      field="handledBy"
                      header="Recruiter's Name"
                      body={recruiterTemplate}
                    />
                    {/* <Column
                      field="requirement"
                      header="Requirement"
                      body={r => show(r.requirement)}
                    /> */}
                    <Column
                      field="priority"
                      header="Priority"
                      body={r => show(r.priority)}
                    />
                    <Column
                      field="positions"
                      header="Total Positions"
                      body={r => show(r.positions)}
                    />
                    <Column
                      field="positions"
                      header="Open Positions"
                      body={r => show(r.ytj)}
                    />
                    <Column
                      field="positions"
                      header="Closed Positions"
                      body={r => show(r.closed_positions)}
                    />
                    <Column
                      field="ytj"
                      header="Yet To Join"
                      body={r => show(r.ytj)}
                    />
                    <Column
                      field="joined"
                      header="Joined"
                      body={row => {
                        // if (!row.joined || row.joined === 0) return "-"
                        return (
                          <div
                            style={{
                              cursor: "pointer",
                              color: "black",
                              fontWeight: 600,
                            }}
                            onClick={() => handleJoinedClick(row)}
                          >
                            {row.joined} ➜
                          </div>
                        )
                      }}
                    />

                    <Column
                      field="Level 1"
                      header="Level 1"
                      // body={r => show(r.Level 1)}
                    />
                    <Column
                      field="Level 2"
                      header="Level 2"
                      // body={r => show(r.Level 2)}
                    />
                    <Column
                      field="Remarks"
                      header="Remarks"
                      body={r => show(r.Remarks)}
                    />
                    <Column header="Status" body={statusTemplate} />
                  </DataTable>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </Container>
      <Modal
        show={showJoinedModal}
        onHide={() => setShowJoinedModal(false)}
        size="md"
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Joined Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {joinedDetails.length === 0 ? (
            <div className="text-center">No data</div>
          ) : (
            <Table bordered>
              <thead className="text-center">
                <tr>
                  <th>Candidate Name</th>
                  <th>Sent By</th>
                  <th>Sent On</th>
                </tr>
              </thead>

              <tbody className="text-center">
                {joinedDetails.map((j, i) => (
                  <tr key={i}>
                    <td>{j.candidate_name || "-"}</td>
                    <td>{j.sent_to_hrms_by || "-"}</td>
                    <td>
                      {j.sent_to_hrms_time
                        ? new Date(j.sent_to_hrms_time).toLocaleDateString(
                            "en-GB"
                          )
                        : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Modal.Body>
      </Modal>
    </div>
  )
}
export default RecruitersReports
